import Coupon from './coupon';

export default class CouponDiscount {
  public cartSubtotal?: number;
  public subtotalAfterCouponApplied?: number;
  public totalDiscount?: number;
  public coupon?: Coupon;
}
